
import { motion } from 'framer-motion';

export default function Features() {
  const features = [
    {
      icon: 'ri-layout-masonry-line',
      title: 'Neue Webseite von Grund auf',
      description: 'Ihre maßgeschneiderte Webseite – kein Baukasten, kein Template. Individuell entwickelt, um Ihre Marke perfekt zu repräsentieren und Besucher in Kunden zu verwandeln.',
      highlights: [
        'Einzigartiges, markengerechtes Design',
        'Responsive für alle Geräte',
        'Conversion-optimierte Struktur'
      ]
    },
    {
      icon: 'ri-refresh-line',
      title: 'Premium Redesign',
      description: 'Ihre bestehende Webseite hat Potenzial? Ich verwandle sie in eine moderne, leistungsstarke Verkaufsmaschine – mit frischem Design und optimierter Nutzererfahrung.',
      highlights: [
        'Modernes, zeitgemäßes Design',
        'Verbesserte Benutzerführung',
        'Höhere Conversion-Rate'
      ]
    },
    {
      icon: 'ri-speed-line',
      title: 'Performance-Optimierung',
      description: 'Schnelle Ladezeiten sind entscheidend für Rankings und Conversions. Ich optimiere Ihre Webseite auf Höchstleistung – unter 2 Sekunden Ladezeit.',
      highlights: [
        'Core Web Vitals Optimierung',
        'Ladezeiten unter 2 Sekunden',
        'Bessere Google-Rankings'
      ]
    },
    {
      icon: 'ri-robot-2-line',
      title: 'AI Chatbots & Automatisierung',
      description: 'Intelligente AI-Chatbots, die rund um die Uhr für Ihre Kunden da sind. Automatisieren Sie Anfragen, Terminbuchungen und Kundensupport – und sparen Sie wertvolle Zeit.',
      highlights: [
        '24/7 automatisierter Kundensupport',
        'Intelligente Terminbuchung',
        'Nahtlose Integration in Ihre Webseite'
      ]
    },
    {
      icon: 'ri-seo-line',
      title: 'SEO & Sichtbarkeit',
      description: 'Werden Sie bei Google gefunden – nicht Ihre Konkurrenz. Ich optimiere Ihre Webseite technisch und inhaltlich für maximale Sichtbarkeit in den Suchergebnissen.',
      highlights: [
        'Technische SEO-Optimierung',
        'Lokale Suchmaschinenoptimierung',
        'Keyword-Strategie & Content'
      ]
    }
  ];

  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-caprasimo mb-6 text-brand-black">
            Meine Leistungen
          </h2>
          <p className="text-xl text-brand-grey max-w-3xl mx-auto">
            Alles aus einer Hand – von der neuen Webseite bis zur AI-Automatisierung
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`group relative bg-brand-beige-light rounded-2xl p-8 hover:bg-white border-2 border-brand-beige hover:border-brand-green transition-all overflow-hidden ${index >= 3 ? 'lg:col-span-1' : ''}`}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-brand-green/10 to-transparent rounded-bl-full transform translate-x-8 -translate-y-8 group-hover:scale-150 transition-transform"></div>
              
              <div className="relative z-10">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl mb-6 group-hover:bg-brand-green group-hover:scale-110 transition-all shadow-md">
                  <i className={`${feature.icon} text-3xl text-brand-green group-hover:text-white transition-colors`}></i>
                </div>
                
                <h3 className="text-xl font-caprasimo mb-4 text-brand-black group-hover:text-brand-green transition-colors">
                  {feature.title}
                </h3>
                <p className="text-brand-grey leading-relaxed mb-6 text-sm">{feature.description}</p>
                
                <ul className="space-y-3">
                  {feature.highlights.map((highlight, i) => (
                    <li key={i} className="flex items-center gap-3 text-brand-grey text-sm">
                      <div className="w-5 h-5 flex items-center justify-center bg-brand-green/10 rounded-full flex-shrink-0">
                        <i className="ri-check-line text-xs text-brand-green"></i>
                      </div>
                      {highlight}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <a 
            href="/contact" 
            className="inline-block bg-brand-green hover:bg-brand-green-light text-white px-10 py-5 rounded-lg text-lg font-semibold transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            Kostenloses Erstgespräch vereinbaren
          </a>
        </motion.div>
      </div>
    </section>
  );
}
